import React from 'react';
import Input from '../elements/Input';

const SponsorDetails = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-2 border-b pb-1 dark:text-white">Sponsor Details (if applicable)</h2>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <Input label="Sponsor's Name" type="text" name="sponsor_name" value={formData.sponsor_name} onChange={handleChange} />
        <Input label="Number/Street" type="text" name="sponsor_number_street" value={formData.sponsor_number_street} onChange={handleChange} />
        <Input label="City" type="text" name="sponsor_city" value={formData.sponsor_city} onChange={handleChange} />
        <Input label="Country" type="text" name="sponsor_country" value={formData.sponsor_country} onChange={handleChange} />
        <Input label="Postal Code" type="text" name="sponsor_postal_code" value={formData.sponsor_postal_code} onChange={handleChange} />
        <Input label="Telephone" type="tel" name="sponsor_telephone" value={formData.sponsor_telephone} onChange={handleChange} />
      </div>
    </div>
  );
};

export default SponsorDetails;
